import { getAuth } from "../modules/auth";
import { getUserByToken } from "../modules/auth/core/_requests";

export interface LoggedUserIdentity {
  id: number;
  name: string;
}

export async function getLoggedUserIdentity(): Promise<LoggedUserIdentity | null> {
  const auth = getAuth();
  if (!auth?.api_token) return null;

  try {
    const response = await getUserByToken(auth.api_token);
    const user = response.data;
    const name = String(
      user.fullname ||
        [user.first_name, user.last_name].filter(Boolean).join(" ").trim(),
    ).trim();
    const id = Number(user.id);
    if (!id || !name) return null;
    return { id, name };
  } catch {
    return null;
  }
}
